/**
 * A rule can add a tag while an earlier save runs, and tags are replaced, not appended. So a queued tag
 * write is the user's diff (added, removed) against `from`, the list they edited from, applied to
 * `latest`, the tags the server holds at send time.
 *
 * When `from` and `latest` hold the same tags nothing changed server-side and the edit goes out as made,
 * in the user's order. Otherwise the server's order is kept and the user's adds are appended.
 */
export function rebaseTags(edit: string[], from: string[], latest: string[]): string[] {
  if (from.length === latest.length && from.every((t) => latest.includes(t))) return edit
  const removed = from.filter((t) => !edit.includes(t))
  const added = edit.filter((t) => !from.includes(t) && !latest.includes(t))
  return [...latest.filter((t) => !removed.includes(t)), ...added]
}
